import './image.scss';
import classNames from 'classnames';
import React from 'react';

interface Props {
  src: string;
  width?: number;
  objectFit?: 'contain' | 'cover';
  alt?: string;
}

export function Image({ src, width, objectFit = 'contain', alt }: Props): JSX.Element {
  return (
    <img
      src={src}
      alt={alt}
      className={classNames('image', `image--${objectFit}`)}
      style={
        {
          '--image-width': width ? `${width}px` : 'auto',
        } as React.CSSProperties
      }
    />
  );
}
